module.exports = __webpack_public_path__ + "img/remove_circle.ebe94ba7.svg";